import { render, staticRenderFns } from "./StudyTable.vue?vue&type=template&id=d92cff86&scoped=true&"
import script from "./StudyTable.vue?vue&type=script&lang=js&"
export * from "./StudyTable.vue?vue&type=script&lang=js&"
import style0 from "./StudyTable.vue?vue&type=style&index=0&id=d92cff86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92cff86",
  null
  
)

export default component.exports